
const GameLog = {
    trace: function(response, message, path) {
        console.log([response, message, path]);
    },
    error: function (response, err, path){
        console.log([response, err, path]);
    },
}
export default GameLog;